const productSubscriptions = class extends HTMLElement {
  constructor() {
    super()

    this.form = this.closest('form')
    this.sellingPlanInput = this.querySelector('[data-selling-plan-input]')
    this.variantSellingPlanGroupings = this.querySelectorAll('[data-selling-plan-variant-grouping]')
    this.variantIdInput = this.form.querySelector('input[name="id"]')
    this.sellingPlanOptionWrappers = this.querySelectorAll('[data-selling-plan-wrapper]')
    this.sellingPlanOptions = this.querySelectorAll('[data-selling-plan]')
    this.sellingPlanTypeLabel = this.querySelector('[data-selling-plan-type]')
    this.sellingPlanOptions.length && this.init()
  }

  init () {
    this.sellingPlanOptions.forEach(sellingPlanOption => {
      sellingPlanOption.addEventListener('change', () => {
        this.sellingPlanInput.value = sellingPlanOption.value
        this.sellingPlanTypeLabel.innerHTML = sellingPlanOption.dataset.frequency
        this.sellingPlanInput.name = sellingPlanOption.value ? 'selling_plan' : ''
        this.variantIdInput.value = sellingPlanOption.dataset.variantId

        this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
          sellingPlanOptionWrapper.classList.toggle('active', sellingPlanOptionWrapper.contains(sellingPlanOption))
        })
      })
    })

    this.sellingPlanOptionWrappers.forEach(sellingPlanOptionWrapper => {
      const list = sellingPlanOptionWrapper.querySelector('[data-selling-plan-details]')
      if (!list) { return }
      list.style.setProperty('--list-height', `${list.scrollHeight}px`);
    })
  }

  variantChanged (variantId) {
    this.variantSellingPlanGroupings.forEach(variantSellingPlanGrouping => {
      variantSellingPlanGrouping.classList.toggle('hidden', variantId !== Number(variantSellingPlanGrouping.dataset.variantId))
      if (variantSellingPlanGrouping.classList.contains('hidden')) { return }

      const options = variantSellingPlanGrouping.querySelectorAll('[data-selling-plan-option]')
      options[0].checked = true
      const changeEvent = new Event('change')
      options[0].dispatchEvent(changeEvent)
    });
  }
}

if (typeof window.customElements.get('product-subscriptions') === 'undefined') {
  window.customElements.define('product-subscriptions', productSubscriptions)
}
